<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs v-model="tab" centered grow>
        <v-tab href="#asignacion_tipo_contrato" @click="actualizarItems('asignacion_tipo_contrato')">
          Asignación de tipo de contrato
        </v-tab>

        <v-tab href="#gestion_contratos" @click="actualizarItems('gestion_contratos')">
          Gestión de contratos
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="asignacion_tipo_contrato">
          <AsignacionTipoContrato ref="asignacion_tipo_contrato" />
        </v-tab-item>

        <v-tab-item value="gestion_contratos">
          <GestionContratos ref="gestion_contratos" />
        </v-tab-item>

      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import AsignacionTipoContrato from "./Contratos/AsignacionTipoContrato.vue"
import GestionContratos from "./Contratos/GestionContratos.vue"

export default {
  components: {
    AsignacionTipoContrato,
    GestionContratos
  },

  data: () => ({
    tab: "asignacion_tipo_contrato"
  }),

  methods: {
    getItems(){
      this.actualizarItems(this.tab);
    },
    actualizarItems(refName) {
      const vista = this.$refs[refName]
      if (vista && typeof vista.getItems === "function") {
        vista.getItems()
      }
    }
  }
}
</script>
